import Select from 'components/form/Inputs/Select';
import { FC, useEffect, useState } from 'react';
import useSWR, { mutate } from 'swr';
import MentorshipReferee from 'types/MentorshipReferee';
import User from 'types/User';
import privateAPI from 'utils/privateAxiosInstance';

type Props = {
  mentor: User | undefined;
};
const ChangeReferee: FC<Props> = ({ mentor }) => {
  const { data: referees } = useSWR<MentorshipReferee[]>('/mentorship-referee');
  const [refereeId, setRefereeId] = useState<number | null>(
    mentor?.mentorshipMainRefereeId || null,
  );

  useEffect(() => {
    setRefereeId(mentor?.mentorshipMainRefereeId || null);
  }, [mentor]);

  const handleChange: React.ChangeEventHandler<HTMLSelectElement> = (e) => {
    const id = e.target.value ? parseInt(e.target.value) : null;
    setRefereeId(id);
    mutate<User>(
      `/user/${mentor?.id}/`,
      { ...mentor, mentorshipMainRefereeId: id },
      false,
    );
    privateAPI
      .post(`/user/mentor/main-referee/${mentor?.id}`, { refereeId: id })
      .catch(() => {
        mutate(`/user/${mentor?.id}/`);
      });
  };

  return (
    <Select
      label="Chargé(e) de mentorat principal(e)"
      value={refereeId?.toString() || ''}
      onChange={handleChange}
    >
      <option value="">-- Sélectionner un(e) chargé(e) de mentorat --</option>
      {referees?.map((referee, idx) => (
        <option value={referee.id} key={idx}>
          {referee.name}
        </option>
      ))}
    </Select>
  );
};

export default ChangeReferee;
